import { gsap } from "gsap";

const SubtitlesBox = () => {
	const block = document.querySelectorAll(".subtitles-box");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const wrapInner = el.querySelector(".subtitles-box__wrap-inner");
		const items = el.querySelector(".subtitles-box__items");
		const itemsLength = el.querySelectorAll(".subtitles-box__item").length;

		wrapInner.append(items.cloneNode(true));

		gsap.to(wrapInner, {
			y: -items.offsetHeight,
			repeat: -1,
			duration: itemsLength * 1.2,
			ease: 'none'
		})
	});
};

export default SubtitlesBox;
